<label [class]="'body p-4 ' + variant()" [for]="name() + '_' + index()">
  <input
    [tabIndex]="tabbable() ? 0 : -1"
    type="radio"
    [value]="optionValue()"
    [attr.name]="name()"
    [name]="name()"
    [id]="name() + '_' + index()"
    [attr.data-testid]="dataTestId() ? dataTestId() + '-' + index() : null"
    [ngModel]="value"
    [disabled]="disabled"
    [checked]="value === optionValue()"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="internalChange($event)"
    (keydown)="onKeydown($event, index())"
    (click)="value === optionValue() ? deselect() : null"
  />
  <div class="radio mr-8"></div>

  <ng-content></ng-content>

  @if (includeResetOption() && value === optionValue() && showResetIcon()) {
    <button class="reset" (click)="resetClicked.emit()">
      <i class="fa-light fa-arrow-rotate-left"></i>
    </button>
  }
</label>
